// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-step {
    padding: 0.5rem 0;
}

.product-media-section {
    margin: 1.25rem 0;
    padding: 1.25rem;
    border: 1px solid var(--border-color, #d8d8d8);
    border-radius: 10px;
    background: var(--surface-color, #fff);
}

.product-media-section > :first-child {
    margin-top: 0;
}

.product-media-section > :last-child {
    margin-bottom: 0;
}

.product-media-section--delivery {
    border-color: #9fbea5;
    background: #f5faf5;
}

.product-media-section-eyebrow {
    margin-bottom: 0.4rem;
    color: var(--text-muted, #5f6a62);
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.product-media-section h2 {
    margin: 0;
}

.product-media-section h3 {
    margin-bottom: 0.4rem;
    font-size: 1rem;
}

.product-media-section-callout {
    padding: 0.65rem 0.75rem;
    border-left: 3px solid #4c8753;
    background: rgba(76, 135, 83, 0.1);
    font-weight: 600;
}

.product-media-picker {
    display: grid;
    gap: 0.75rem;
}

.product-media-picker-selection {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    min-height: 76px;
    padding: 0.6rem;
    border: 1px solid var(--border-color, #c8d7ca);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.72);
}

.product-media-picker-selection > div:last-child {
    display: grid;
    min-width: 0;
    gap: 0.2rem;
}

.product-media-picker-selection strong,
.product-media-picker-selection span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.product-media-picker-selection span {
    color: var(--text-muted, #666);
    font-size: 0.85rem;
}

.product-media-picker-preview {
    display: grid;
    width: 72px;
    height: 60px;
    flex: none;
    place-items: center;
    overflow: hidden;
    border-radius: 5px;
    background: #e7eee8;
}

.product-media-picker-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.product-media-picker-preview i {
    color: #456d4a;
    font-size: 1.8rem;
}

.product-media-picker-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.product-media-autosave {
    margin: 0 0 1rem;
    color: var(--text-muted, #666);
    font-size: 0.9rem;
}

.product-media-autosave.is-saving {
    color: #2c6c3a;
}

.product-media-autosave.is-error {
    color: #9b2c2c;
    font-weight: 600;
}

.product-gallery-editor-empty {
    margin: 1rem 0;
    padding: 1rem;
    border: 1px dashed var(--border-color, #c8c8c8);
    border-radius: 8px;
    color: var(--text-muted, #666);
}

div.page section.product-subpane section.product-gallery-editor {
    margin-top: 1.5rem;
}

.product-gallery-editor > h3 {
    margin-top: 0;
}

.product-gallery-editor-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem;
}

.product-gallery-editor-item {
    min-width: 0;
    margin: 0;
    overflow: hidden;
    border: 1px solid var(--border-color, #d8d8d8);
    border-radius: 8px;
    background: var(--surface-color, #fff);
}

.product-gallery-editor-preview {
    display: grid;
    place-items: center;
    aspect-ratio: 4 / 3;
    overflow: hidden;
    background: #edf1ee;
}

.product-gallery-editor-preview img,
.product-gallery-editor-preview video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.product-gallery-editor-file {
    display: grid;
    justify-items: center;
    gap: 0.5rem;
    padding: 1rem;
    text-align: center;
    overflow-wrap: anywhere;
}

.product-gallery-editor-file i {
    font-size: 2.5rem;
}

.product-gallery-editor-item figcaption {
    display: grid;
    gap: 0.4rem;
    padding: 0.85rem;
}

.product-gallery-editor-item figcaption label {
    font-weight: 700;
}

.product-gallery-editor-item figcaption input {
    box-sizing: border-box;
    width: 100%;
}

.product-gallery-editor-item figcaption .button {
    justify-self: start;
    margin: 0;
}

.product-gallery-editor-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
    padding: 0 0.85rem 0.85rem;
}

.product-gallery-editor-actions .button {
    min-height: 44px;
    margin: 0;
}

@media (max-width: 600px) {
    .product-media-section {
        padding: 1rem;
    }

    .product-gallery-editor-grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .product-gallery-editor-actions .button {
        flex: 1 1 calc(50% - 0.45rem);
    }
}

.digital-file-set-editor {
    margin-top: 1rem;
    padding: 1rem 0 0;
    border-top: 1px solid #b8cdbb;
}

.digital-file-set-list {
    display: grid;
    gap: 0.65rem;
    padding: 0;
    list-style: none;
}

.digital-file-set-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.75rem;
    border: 1px solid var(--border-color, #d8d8d8);
    border-radius: 6px;
}

.digital-file-set-preview {
    display: grid;
    width: 44px;
    height: 44px;
    flex: none;
    place-items: center;
    overflow: hidden;
    border-radius: 5px;
    background: #e7eee8;
}

.digital-file-set-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.digital-file-set-preview i {
    color: #456d4a;
}

.digital-file-set-details {
    min-width: 0;
    display: grid;
    gap: 0.2rem;
}

.digital-file-set-details strong {
    overflow-wrap: anywhere;
}

.digital-file-set-details span,
.digital-file-set-library-item span {
    color: var(--text-muted, #666);
    font-size: 0.85rem;
}

.digital-file-set-actions,
.digital-file-set-add-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.digital-file-set-add-actions {
    margin-top: 0.75rem;
}

.digital-file-set-actions .button {
    min-width: 44px;
    min-height: 44px;
    margin: 0;
}

@media (max-width: 600px) {
    .digital-file-set-row {
        align-items: stretch;
        flex-direction: column;
    }

    .digital-file-set-actions .button {
        flex: 1;
    }
}

.product-booking-summary {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    margin-top: 0.65rem;
    padding: 0.65rem 0.75rem;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    background: #fafafa;
}

.product-booking-summary__status {
    flex: none;
    padding: 0.2rem 0.5rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 700;
}

.product-booking-summary__status--ready {
    color: #235d29;
    background: #dff2e1;
}

.product-booking-summary__status--warning {
    color: #7a4b00;
    background: #fff0c7;
}

.product-booking-summary__text {
    flex: 1;
    color: #555;
    font-size: 0.85rem;
}

.product-booking-modal__actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
}

.product-booking-draft-summary {
    margin-top: 0;
    margin-bottom: 1.25rem;
}

.booking-settings__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 0 1rem;
}

.booking-settings__fieldset {
    min-width: 0;
    margin: 1.25rem 0 0;
    padding: 1rem;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
}

.booking-settings__fieldset legend {
    padding: 0 0.4rem;
    font-weight: 700;
}

.booking-settings__resource {
    flex: 1;
    margin: 0.6rem 0;
}

.booking-settings__resource-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.booking-settings__resource-row > .button {
    flex-shrink: 0;
}

.booking-settings__fees {
    margin: 1.25rem 0;
}

.booking-settings__subheading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 0.75rem;
}

.booking-settings__subheading h4 {
    margin: 0;
}

.booking-settings__fee {
    display: grid;
    grid-template-columns: minmax(180px, 2fr) minmax(140px, 1fr) auto auto;
    align-items: end;
    gap: 0.75rem;
    padding: 0.75rem 0;
    border-top: 1px solid #e6e6e6;
}

.booking-settings__fee .group {
    margin: 0;
}

.booking-settings__fee-refundable {
    min-height: 42px;
    margin: 0;
}

[data-theme="dark"] .product-booking-summary {
    border-color: #3a463e;
    background: #1c2620;
}

[data-theme="dark"] .product-booking-summary__text {
    color: #b6c6bc;
}

[data-theme="dark"] .product-booking-summary__status--ready {
    color: #b9e79c;
    background: #29452e;
}

[data-theme="dark"] .product-booking-summary__status--warning {
    color: #ffd98a;
    background: #4b3b1f;
}

[data-theme="dark"] .booking-settings__fieldset,
[data-theme="dark"] .booking-settings__fee {
    border-color: #3a463e;
}

.wizard-nav {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #e0e0e0;
}
[data-theme="dark"] .wizard-nav { border-top-color: #2c3a33; }

.wizard-nav .button:first-child {
    margin-right: auto;
}

.product-wizard {
    padding: 1rem 0;
}

div.page section.product-subpane {
    margin-bottom: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.product-subpane > .wizard-step {
    padding: 0;
}

.product-subpane .wizard-step > h2:not(:first-child) {
    margin-top: 2rem;
}

div.page section.product-subpane section:not(.product-media-section) {
    max-width: none;
    margin-bottom: 1.5rem;
    padding: 1rem;
    border-radius: 8px;
    background: #fafafa;
}

div.page section.product-subpane section:not(.product-media-section):last-of-type {
    margin-bottom: 0;
}

.product-subpane section > h3:first-child {
    margin-top: 0;
}

[data-theme="dark"] .product-subpane {
    box-shadow: none;
}

[data-theme="dark"] div.page section.product-subpane section:not(.product-media-section) {
    background: #18221c;
}

[data-theme="dark"] .product-media-section--listing {
    background: #18221c;
}

[data-theme="dark"] .product-media-section--delivery {
    border-color: #42684a;
    background: #17291b;
}

[data-theme="dark"] .product-media-section-callout {
    border-left-color: #76ad7d;
    background: rgba(118, 173, 125, 0.16);
}

[data-theme="dark"] .product-media-picker-selection {
    border-color: #42684a;
    background: rgba(24, 34, 28, 0.7);
}

[data-theme="dark"] .product-media-picker-preview {
    background: #24392a;
}

[data-theme="dark"] .digital-file-set-preview {
    background: #24392a;
}

[data-theme="dark"] .product-media-picker-preview i,
[data-theme="dark"] .digital-file-set-preview i,
[data-theme="dark"] .product-media-autosave.is-saving {
    color: #8cc493;
}

.wizard-publish-summary {
    overflow: hidden;
    margin-bottom: 1.5rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
}

.wizard-publish-summary__section {
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #e0e0e0;
}

.wizard-publish-summary__header h3 {
    margin: 0;
}

.wizard-publish-summary__image {
    max-width: 200px;
    max-height: 150px;
    border-radius: 4px;
    object-fit: cover;
}

.wizard-publish-summary__table {
    width: 100%;
    border-collapse: collapse;
}

.wizard-publish-summary__table td {
    padding: 0.5rem 0.75rem;
    border-bottom: 1px solid #eee;
    vertical-align: top;
}

.wizard-publish-summary__table tr:last-child td {
    border-bottom: 0;
}

.wizard-publish-summary__table .wizard-publish-summary__label {
    width: 130px;
    color: #666;
}

.wizard-publish-summary__table td::before {
    color: #666;
}

[data-theme="dark"] .wizard-publish-summary {
    border-color: #3a463e;
    background: #1c2620;
}

[data-theme="dark"] .wizard-publish-summary__section {
    border-bottom-color: #3a463e;
}

[data-theme="dark"] .wizard-publish-summary__table td {
    border-bottom-color: #2c3a33;
}

[data-theme="dark"] .wizard-publish-summary__table tr {
    border-color: #2c3a33;
}

[data-theme="dark"] .wizard-publish-summary__table td::before,
[data-theme="dark"] .wizard-publish-summary__table .wizard-publish-summary__label {
    color: #9fb0a6;
}

.wizard-publish-summary__files {
    margin: 0;
    padding: 0;
    list-style: none;
    display: grid;
    gap: 0.5rem;
}

.wizard-publish-summary__file {
    display: flex;
    align-items: center;
    gap: 0.6rem;
}

.wizard-publish-summary__file-preview {
    display: grid;
    width: 40px;
    height: 40px;
    flex: none;
    place-items: center;
    overflow: hidden;
    border-radius: 5px;
    background: #e7eee8;
}

.wizard-publish-summary__file-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.wizard-publish-summary__file-preview i {
    color: #456d4a;
}

.wizard-publish-summary__file-meta {
    display: grid;
    gap: 0.15rem;
    min-width: 0;
}

.wizard-publish-summary__file-meta strong {
    overflow-wrap: anywhere;
}

.wizard-publish-summary__file-meta span {
    color: #666;
    font-size: 0.85rem;
}

.wizard-publish-summary__file-note {
    color: #666;
    font-size: 0.85rem;
}

.wizard-publish-warnings {
    margin-bottom: 1.5rem;
}

[data-theme="dark"] .wizard-publish-summary__file-preview {
    background: #24312a;
}

[data-theme="dark"] .wizard-publish-summary__file-preview i,
[data-theme="dark"] .wizard-publish-summary__file-meta span,
[data-theme="dark"] .wizard-publish-summary__file-note {
    color: #9fb0a6;
}

.stock-cell-controls,
.variant-price-editor {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
}

.stock-cell-input,
.variant-price-editor input {
    width: 90px;
    height: 31px;
}

.general-stock-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 0.75rem;
}

.general-stock-choice-card {
    min-height: 118px;
    padding: 1rem;
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    background: #fff;
    text-align: left;
    cursor: pointer;
}

.general-stock-choice-card strong,
.general-stock-choice-card span {
    display: block;
}

.general-stock-choice-card strong {
    margin-bottom: 0.65rem;
    color: #222;
}

.general-stock-choice-card span {
    color: #555;
    line-height: 1.35;
}

.general-stock-choice-card.selected {
    border-color: #111;
    box-shadow: 0 0 0 2px #111 inset;
}

.general-stock-limited {
    display: flex;
    align-items: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
}

.general-stock-limited .group {
    margin: 0;
}

.general-stock-limited input {
    width: 140px;
}

[data-theme="dark"] .general-stock-choice-card {
    border-color: #3a463e;
    background: #1c2620;
}

[data-theme="dark"] .general-stock-choice-card strong {
    color: #e3ece6;
}

[data-theme="dark"] .general-stock-choice-card span {
    color: #9fb0a6;
}

[data-theme="dark"] .general-stock-choice-card.selected {
    border-color: #e3ece6;
    box-shadow: 0 0 0 2px #e3ece6 inset;
}

.variant-price-editor {
    align-items: flex-start;
}

.variant-price-help {
    flex-basis: 100%;
    margin: 0;
}

@media (max-width: 600px) {
    .wizard-nav {
        flex-direction: column;
    }

    .wizard-nav .button {
        width: 100%;
        text-align: center;
    }

    .wizard-nav .button:first-child {
        margin-right: 0;
    }

    .stock-cell-input,
    .variant-price-editor input {
        width: 100%;
    }

    .general-stock-limited {
        align-items: stretch;
        flex-direction: column;
    }

    .general-stock-limited input {
        width: 100%;
    }

    .product-booking-summary {
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .product-booking-summary__text {
        flex-basis: calc(100% - 90px);
    }

    .product-booking-summary .button {
        width: 100%;
    }

    .product-booking-modal__actions .button {
        flex: 1;
    }

    .booking-settings__fee {
        grid-template-columns: 1fr;
        align-items: stretch;
    }

    .booking-settings__resource-row {
        align-items: stretch;
        flex-direction: column;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Product/ProductWizard.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,+CAA+C;IAC/C,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,OAAO;IACX;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sEAAsE;IACtE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;AACjC;AACA,kCAAkC,yBAAyB,EAAE;;AAE7D;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;AACJ","sourcesContent":[".wizard-step {\n    padding: 0.5rem 0;\n}\n\n.product-media-section {\n    margin: 1.25rem 0;\n    padding: 1.25rem;\n    border: 1px solid var(--border-color, #d8d8d8);\n    border-radius: 10px;\n    background: var(--surface-color, #fff);\n}\n\n.product-media-section > :first-child {\n    margin-top: 0;\n}\n\n.product-media-section > :last-child {\n    margin-bottom: 0;\n}\n\n.product-media-section--delivery {\n    border-color: #9fbea5;\n    background: #f5faf5;\n}\n\n.product-media-section-eyebrow {\n    margin-bottom: 0.4rem;\n    color: var(--text-muted, #5f6a62);\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.product-media-section h2 {\n    margin: 0;\n}\n\n.product-media-section h3 {\n    margin-bottom: 0.4rem;\n    font-size: 1rem;\n}\n\n.product-media-section-callout {\n    padding: 0.65rem 0.75rem;\n    border-left: 3px solid #4c8753;\n    background: rgba(76, 135, 83, 0.1);\n    font-weight: 600;\n}\n\n.product-media-picker {\n    display: grid;\n    gap: 0.75rem;\n}\n\n.product-media-picker-selection {\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    min-height: 76px;\n    padding: 0.6rem;\n    border: 1px solid var(--border-color, #c8d7ca);\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.72);\n}\n\n.product-media-picker-selection > div:last-child {\n    display: grid;\n    min-width: 0;\n    gap: 0.2rem;\n}\n\n.product-media-picker-selection strong,\n.product-media-picker-selection span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.product-media-picker-selection span {\n    color: var(--text-muted, #666);\n    font-size: 0.85rem;\n}\n\n.product-media-picker-preview {\n    display: grid;\n    width: 72px;\n    height: 60px;\n    flex: none;\n    place-items: center;\n    overflow: hidden;\n    border-radius: 5px;\n    background: #e7eee8;\n}\n\n.product-media-picker-preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.product-media-picker-preview i {\n    color: #456d4a;\n    font-size: 1.8rem;\n}\n\n.product-media-picker-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.45rem;\n}\n\n.product-media-autosave {\n    margin: 0 0 1rem;\n    color: var(--text-muted, #666);\n    font-size: 0.9rem;\n}\n\n.product-media-autosave.is-saving {\n    color: #2c6c3a;\n}\n\n.product-media-autosave.is-error {\n    color: #9b2c2c;\n    font-weight: 600;\n}\n\n.product-gallery-editor-empty {\n    margin: 1rem 0;\n    padding: 1rem;\n    border: 1px dashed var(--border-color, #c8c8c8);\n    border-radius: 8px;\n    color: var(--text-muted, #666);\n}\n\ndiv.page section.product-subpane section.product-gallery-editor {\n    margin-top: 1.5rem;\n}\n\n.product-gallery-editor > h3 {\n    margin-top: 0;\n}\n\n.product-gallery-editor-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 1rem;\n}\n\n.product-gallery-editor-item {\n    min-width: 0;\n    margin: 0;\n    overflow: hidden;\n    border: 1px solid var(--border-color, #d8d8d8);\n    border-radius: 8px;\n    background: var(--surface-color, #fff);\n}\n\n.product-gallery-editor-preview {\n    display: grid;\n    place-items: center;\n    aspect-ratio: 4 / 3;\n    overflow: hidden;\n    background: #edf1ee;\n}\n\n.product-gallery-editor-preview img,\n.product-gallery-editor-preview video {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.product-gallery-editor-file {\n    display: grid;\n    justify-items: center;\n    gap: 0.5rem;\n    padding: 1rem;\n    text-align: center;\n    overflow-wrap: anywhere;\n}\n\n.product-gallery-editor-file i {\n    font-size: 2.5rem;\n}\n\n.product-gallery-editor-item figcaption {\n    display: grid;\n    gap: 0.4rem;\n    padding: 0.85rem;\n}\n\n.product-gallery-editor-item figcaption label {\n    font-weight: 700;\n}\n\n.product-gallery-editor-item figcaption input {\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.product-gallery-editor-item figcaption .button {\n    justify-self: start;\n    margin: 0;\n}\n\n.product-gallery-editor-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.45rem;\n    padding: 0 0.85rem 0.85rem;\n}\n\n.product-gallery-editor-actions .button {\n    min-height: 44px;\n    margin: 0;\n}\n\n@media (max-width: 600px) {\n    .product-media-section {\n        padding: 1rem;\n    }\n\n    .product-gallery-editor-grid {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .product-gallery-editor-actions .button {\n        flex: 1 1 calc(50% - 0.45rem);\n    }\n}\n\n.digital-file-set-editor {\n    margin-top: 1rem;\n    padding: 1rem 0 0;\n    border-top: 1px solid #b8cdbb;\n}\n\n.digital-file-set-list {\n    display: grid;\n    gap: 0.65rem;\n    padding: 0;\n    list-style: none;\n}\n\n.digital-file-set-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.75rem;\n    border: 1px solid var(--border-color, #d8d8d8);\n    border-radius: 6px;\n}\n\n.digital-file-set-preview {\n    display: grid;\n    width: 44px;\n    height: 44px;\n    flex: none;\n    place-items: center;\n    overflow: hidden;\n    border-radius: 5px;\n    background: #e7eee8;\n}\n\n.digital-file-set-preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.digital-file-set-preview i {\n    color: #456d4a;\n}\n\n.digital-file-set-details {\n    min-width: 0;\n    display: grid;\n    gap: 0.2rem;\n}\n\n.digital-file-set-details strong {\n    overflow-wrap: anywhere;\n}\n\n.digital-file-set-details span,\n.digital-file-set-library-item span {\n    color: var(--text-muted, #666);\n    font-size: 0.85rem;\n}\n\n.digital-file-set-actions,\n.digital-file-set-add-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.45rem;\n}\n\n.digital-file-set-add-actions {\n    margin-top: 0.75rem;\n}\n\n.digital-file-set-actions .button {\n    min-width: 44px;\n    min-height: 44px;\n    margin: 0;\n}\n\n@media (max-width: 600px) {\n    .digital-file-set-row {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .digital-file-set-actions .button {\n        flex: 1;\n    }\n}\n\n.product-booking-summary {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n    margin-top: 0.65rem;\n    padding: 0.65rem 0.75rem;\n    border: 1px solid #d8d8d8;\n    border-radius: 6px;\n    background: #fafafa;\n}\n\n.product-booking-summary__status {\n    flex: none;\n    padding: 0.2rem 0.5rem;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    font-weight: 700;\n}\n\n.product-booking-summary__status--ready {\n    color: #235d29;\n    background: #dff2e1;\n}\n\n.product-booking-summary__status--warning {\n    color: #7a4b00;\n    background: #fff0c7;\n}\n\n.product-booking-summary__text {\n    flex: 1;\n    color: #555;\n    font-size: 0.85rem;\n}\n\n.product-booking-modal__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n}\n\n.product-booking-draft-summary {\n    margin-top: 0;\n    margin-bottom: 1.25rem;\n}\n\n.booking-settings__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n    gap: 0 1rem;\n}\n\n.booking-settings__fieldset {\n    min-width: 0;\n    margin: 1.25rem 0 0;\n    padding: 1rem;\n    border: 1px solid #d8d8d8;\n    border-radius: 6px;\n}\n\n.booking-settings__fieldset legend {\n    padding: 0 0.4rem;\n    font-weight: 700;\n}\n\n.booking-settings__resource {\n    flex: 1;\n    margin: 0.6rem 0;\n}\n\n.booking-settings__resource-row {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.booking-settings__resource-row > .button {\n    flex-shrink: 0;\n}\n\n.booking-settings__fees {\n    margin: 1.25rem 0;\n}\n\n.booking-settings__subheading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    margin-bottom: 0.75rem;\n}\n\n.booking-settings__subheading h4 {\n    margin: 0;\n}\n\n.booking-settings__fee {\n    display: grid;\n    grid-template-columns: minmax(180px, 2fr) minmax(140px, 1fr) auto auto;\n    align-items: end;\n    gap: 0.75rem;\n    padding: 0.75rem 0;\n    border-top: 1px solid #e6e6e6;\n}\n\n.booking-settings__fee .group {\n    margin: 0;\n}\n\n.booking-settings__fee-refundable {\n    min-height: 42px;\n    margin: 0;\n}\n\n[data-theme=\"dark\"] .product-booking-summary {\n    border-color: #3a463e;\n    background: #1c2620;\n}\n\n[data-theme=\"dark\"] .product-booking-summary__text {\n    color: #b6c6bc;\n}\n\n[data-theme=\"dark\"] .product-booking-summary__status--ready {\n    color: #b9e79c;\n    background: #29452e;\n}\n\n[data-theme=\"dark\"] .product-booking-summary__status--warning {\n    color: #ffd98a;\n    background: #4b3b1f;\n}\n\n[data-theme=\"dark\"] .booking-settings__fieldset,\n[data-theme=\"dark\"] .booking-settings__fee {\n    border-color: #3a463e;\n}\n\n.wizard-nav {\n    display: flex;\n    gap: 0.75rem;\n    justify-content: flex-end;\n    margin-top: 1.5rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e0e0e0;\n}\n[data-theme=\"dark\"] .wizard-nav { border-top-color: #2c3a33; }\n\n.wizard-nav .button:first-child {\n    margin-right: auto;\n}\n\n.product-wizard {\n    padding: 1rem 0;\n}\n\ndiv.page section.product-subpane {\n    margin-bottom: 1.5rem;\n    border-radius: 8px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.product-subpane > .wizard-step {\n    padding: 0;\n}\n\n.product-subpane .wizard-step > h2:not(:first-child) {\n    margin-top: 2rem;\n}\n\ndiv.page section.product-subpane section:not(.product-media-section) {\n    max-width: none;\n    margin-bottom: 1.5rem;\n    padding: 1rem;\n    border-radius: 8px;\n    background: #fafafa;\n}\n\ndiv.page section.product-subpane section:not(.product-media-section):last-of-type {\n    margin-bottom: 0;\n}\n\n.product-subpane section > h3:first-child {\n    margin-top: 0;\n}\n\n[data-theme=\"dark\"] .product-subpane {\n    box-shadow: none;\n}\n\n[data-theme=\"dark\"] div.page section.product-subpane section:not(.product-media-section) {\n    background: #18221c;\n}\n\n[data-theme=\"dark\"] .product-media-section--listing {\n    background: #18221c;\n}\n\n[data-theme=\"dark\"] .product-media-section--delivery {\n    border-color: #42684a;\n    background: #17291b;\n}\n\n[data-theme=\"dark\"] .product-media-section-callout {\n    border-left-color: #76ad7d;\n    background: rgba(118, 173, 125, 0.16);\n}\n\n[data-theme=\"dark\"] .product-media-picker-selection {\n    border-color: #42684a;\n    background: rgba(24, 34, 28, 0.7);\n}\n\n[data-theme=\"dark\"] .product-media-picker-preview {\n    background: #24392a;\n}\n\n[data-theme=\"dark\"] .digital-file-set-preview {\n    background: #24392a;\n}\n\n[data-theme=\"dark\"] .product-media-picker-preview i,\n[data-theme=\"dark\"] .digital-file-set-preview i,\n[data-theme=\"dark\"] .product-media-autosave.is-saving {\n    color: #8cc493;\n}\n\n.wizard-publish-summary {\n    overflow: hidden;\n    margin-bottom: 1.5rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background: #fafafa;\n}\n\n.wizard-publish-summary__section {\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.wizard-publish-summary__header h3 {\n    margin: 0;\n}\n\n.wizard-publish-summary__image {\n    max-width: 200px;\n    max-height: 150px;\n    border-radius: 4px;\n    object-fit: cover;\n}\n\n.wizard-publish-summary__table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.wizard-publish-summary__table td {\n    padding: 0.5rem 0.75rem;\n    border-bottom: 1px solid #eee;\n    vertical-align: top;\n}\n\n.wizard-publish-summary__table tr:last-child td {\n    border-bottom: 0;\n}\n\n.wizard-publish-summary__table .wizard-publish-summary__label {\n    width: 130px;\n    color: #666;\n}\n\n.wizard-publish-summary__table td::before {\n    color: #666;\n}\n\n[data-theme=\"dark\"] .wizard-publish-summary {\n    border-color: #3a463e;\n    background: #1c2620;\n}\n\n[data-theme=\"dark\"] .wizard-publish-summary__section {\n    border-bottom-color: #3a463e;\n}\n\n[data-theme=\"dark\"] .wizard-publish-summary__table td {\n    border-bottom-color: #2c3a33;\n}\n\n[data-theme=\"dark\"] .wizard-publish-summary__table tr {\n    border-color: #2c3a33;\n}\n\n[data-theme=\"dark\"] .wizard-publish-summary__table td::before,\n[data-theme=\"dark\"] .wizard-publish-summary__table .wizard-publish-summary__label {\n    color: #9fb0a6;\n}\n\n.wizard-publish-summary__files {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: grid;\n    gap: 0.5rem;\n}\n\n.wizard-publish-summary__file {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n}\n\n.wizard-publish-summary__file-preview {\n    display: grid;\n    width: 40px;\n    height: 40px;\n    flex: none;\n    place-items: center;\n    overflow: hidden;\n    border-radius: 5px;\n    background: #e7eee8;\n}\n\n.wizard-publish-summary__file-preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.wizard-publish-summary__file-preview i {\n    color: #456d4a;\n}\n\n.wizard-publish-summary__file-meta {\n    display: grid;\n    gap: 0.15rem;\n    min-width: 0;\n}\n\n.wizard-publish-summary__file-meta strong {\n    overflow-wrap: anywhere;\n}\n\n.wizard-publish-summary__file-meta span {\n    color: #666;\n    font-size: 0.85rem;\n}\n\n.wizard-publish-summary__file-note {\n    color: #666;\n    font-size: 0.85rem;\n}\n\n.wizard-publish-warnings {\n    margin-bottom: 1.5rem;\n}\n\n[data-theme=\"dark\"] .wizard-publish-summary__file-preview {\n    background: #24312a;\n}\n\n[data-theme=\"dark\"] .wizard-publish-summary__file-preview i,\n[data-theme=\"dark\"] .wizard-publish-summary__file-meta span,\n[data-theme=\"dark\"] .wizard-publish-summary__file-note {\n    color: #9fb0a6;\n}\n\n.stock-cell-controls,\n.variant-price-editor {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.stock-cell-input,\n.variant-price-editor input {\n    width: 90px;\n    height: 31px;\n}\n\n.general-stock-card-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n    gap: 0.75rem;\n}\n\n.general-stock-choice-card {\n    min-height: 118px;\n    padding: 1rem;\n    border: 1px solid #d8d8d8;\n    border-radius: 8px;\n    background: #fff;\n    text-align: left;\n    cursor: pointer;\n}\n\n.general-stock-choice-card strong,\n.general-stock-choice-card span {\n    display: block;\n}\n\n.general-stock-choice-card strong {\n    margin-bottom: 0.65rem;\n    color: #222;\n}\n\n.general-stock-choice-card span {\n    color: #555;\n    line-height: 1.35;\n}\n\n.general-stock-choice-card.selected {\n    border-color: #111;\n    box-shadow: 0 0 0 2px #111 inset;\n}\n\n.general-stock-limited {\n    display: flex;\n    align-items: flex-end;\n    gap: 0.75rem;\n    margin-top: 1rem;\n}\n\n.general-stock-limited .group {\n    margin: 0;\n}\n\n.general-stock-limited input {\n    width: 140px;\n}\n\n[data-theme=\"dark\"] .general-stock-choice-card {\n    border-color: #3a463e;\n    background: #1c2620;\n}\n\n[data-theme=\"dark\"] .general-stock-choice-card strong {\n    color: #e3ece6;\n}\n\n[data-theme=\"dark\"] .general-stock-choice-card span {\n    color: #9fb0a6;\n}\n\n[data-theme=\"dark\"] .general-stock-choice-card.selected {\n    border-color: #e3ece6;\n    box-shadow: 0 0 0 2px #e3ece6 inset;\n}\n\n.variant-price-editor {\n    align-items: flex-start;\n}\n\n.variant-price-help {\n    flex-basis: 100%;\n    margin: 0;\n}\n\n@media (max-width: 600px) {\n    .wizard-nav {\n        flex-direction: column;\n    }\n\n    .wizard-nav .button {\n        width: 100%;\n        text-align: center;\n    }\n\n    .wizard-nav .button:first-child {\n        margin-right: 0;\n    }\n\n    .stock-cell-input,\n    .variant-price-editor input {\n        width: 100%;\n    }\n\n    .general-stock-limited {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .general-stock-limited input {\n        width: 100%;\n    }\n\n    .product-booking-summary {\n        align-items: flex-start;\n        flex-wrap: wrap;\n    }\n\n    .product-booking-summary__text {\n        flex-basis: calc(100% - 90px);\n    }\n\n    .product-booking-summary .button {\n        width: 100%;\n    }\n\n    .product-booking-modal__actions .button {\n        flex: 1;\n    }\n\n    .booking-settings__fee {\n        grid-template-columns: 1fr;\n        align-items: stretch;\n    }\n\n    .booking-settings__resource-row {\n        align-items: stretch;\n        flex-direction: column;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
